import Flex from '@Components/Bases/Flex';
import OtherExplanation from '@Containers/OtherExplanations/OtherExplanations';
import { useGetFinancialOtherAndComplete } from '@Domains/FinancialStatements';
import { Alert, Box, CircularProgress, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import FinancialStatementsCheckbox from './Containers/FinancialStatementsOneReport/FinancialStatementsCheckbox';
import FinancialStatementsOneReport from './Containers/FinancialStatementsOneReport/FinancialStatementsOneReport';
import FinancialStatementsProvider from './Containers/FinancialStatementsProvider';
import { IFinancialStatementsFormValues } from './Containers/FinancialStatementsProvider/types';
import FinancialStatementsFooter from './Containers/FinancialStatemetsFooter';

const FinancialStatements = () => {
  const { id } = useParams();
  const location = useLocation();
  const currentPath = location.pathname.split('/').pop();

  const [{ data, loading, error }, refetch] = useGetFinancialOtherAndComplete(
    Number(id)
  );

  useEffect(() => {
    if (currentPath === 'financial-statements') {
      refetch().catch((error) => {
        if (error.name !== 'CanceledError') {
          console.error('Failed to fetch financial statements :', error);
        }
      });
    }
  }, [currentPath, refetch]);

  const initialValues: IFinancialStatementsFormValues = data;

  if (loading) {
    return (
      <Flex justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress size={50} />
      </Flex>
    );
  }

  if (error) {
    return (
      <Box p={2}>
        <Alert severity={'error'}>
          ไม่สามารถโหลดข้อมูลเป้าหมาย แผนการดำเนินงาน และการบริหารความเสี่ยงได้
        </Alert>
      </Box>
    );
  }

  if (!initialValues) {
    return null;
  }

  return (
    <FinancialStatementsProvider initialValues={initialValues}>
      <Flex flexDirection={'column'} gap={2} p={2} mb={8}>
        <Typography variant="h3">ส่วนที่ 1 การประกอบธุรกิจ</Typography>
        <FinancialStatementsOneReport />
        <OtherExplanation />
        <FinancialStatementsCheckbox />
      </Flex>
      <FinancialStatementsFooter />
    </FinancialStatementsProvider>
  );
};

export default FinancialStatements;
